module.exports = __webpack_public_path__ + "static/media/20180825_143729.42474ec5.jpg";